import { Text } from "@/elements"
import parse, { Element } from "html-react-parser"
import { CSSProperties } from "react"

export interface WysiwygProps {
  id?: number
  block_wysiwyg: string
}

function processChildren(children: any[], parentStyle: CSSProperties = {}) {
  return children.map((child, i) => {
    if (child instanceof Element) {
      if (child.name === "a") {
        return (
          <a
            key={i}
            href={child.attribs.href}
            target={child.attribs.target}
            rel={child.attribs.rel}
            className="text-primary-3 hover:underline"
            style={parentStyle}>
            {processChildren(child.children)}
          </a>
        )
      }
      if (child.name === "em") {
        const newStyle = { ...parentStyle, fontStyle: "italic" }
        return (
          <Text key={i} element="span" style={newStyle}>
            {processChildren(child.children, newStyle)}
          </Text>
        )
      }
      if (child.name === "strong") {
        const newStyle = { ...parentStyle, fontWeight: 600 }
        return (
          <Text key={i} element="span" style={newStyle}>
            {processChildren(child.children, newStyle)}
          </Text>
        )
      }
      if (child.name === "span") {
        const styleString = child.attribs.style || ""
        // Parse inline styles into an object
        const inlineStyles = styleString
          .split(";")
          .filter(Boolean)
          .reduce<CSSProperties>((acc, style) => {
            const [property, value] = style.split(":").map(s => s.trim())
            if (property && value) {
              // Convert CSS property names to camelCase for React
              const camelProperty = property.replace(/-([a-z])/g, g => g[1].toUpperCase())
              return { ...acc, [camelProperty]: value }
            }
            return acc
          }, {})

        const newStyle = { ...parentStyle, ...inlineStyles }
        return (
          <Text key={i} element="span" style={newStyle}>
            {processChildren(child.children, newStyle)}
          </Text>
        )
      }
      if (child.name === "br") {
        return <br key={i} />
      }
      if (child.name === "img") {
        return <img key={i} src={child.attribs.src} alt={child.attribs.alt} className="my-4 rounded-lg" />
      }
    }
    return child.type === "text" ? child.data : ""
  })
}

function transformHtml(content: string | null | undefined) {
  if (!content) return null

  return parse(content, {
    replace: domNode => {
      if (domNode instanceof Element) {
        // Handle headings
        if (domNode.name?.match(/^h[1-6]$/)) {
          const variant = domNode.name as "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
          return (
            <Text element={variant} variant={variant}>
              {processChildren(domNode.children)}
            </Text>
          )
        }

        if (domNode.name === "p") {
          return <Text className="mt-4">{processChildren(domNode.children)}</Text>
        }
      }
    },
  })
}

export const Wysiwyg: React.FC<WysiwygProps> = props => {
  return transformHtml(props.block_wysiwyg)
}
